import React, { useState } from "react";
import { getEstDateTime } from "../../utilities/util";

const PrivacyPolicy = () => {
  const [isAccepted, setIsAccepted] = useState(false);

  const handleAccept = () => {
    setIsAccepted(!isAccepted);
  };

  return (
    <div className="max-w-3xl mx-auto p-6 bg-black bg-opacity-40 backdrop-blur rounded-2xl shadow-2xl text-white mt-8 mb-8">
      <h2 className="text-2xl font-semibold text-yellow-300 text-center mb-4">
        Privacy Policy
      </h2>
      
      <p className="text-lg mb-4">
        <strong>DELIGHT RESTAURANT GROUP</strong><br />
        All employee-initiated schedule changes must be approved using this form to be completed by the employee and manager at or before the start of the schedule change. For changes to general availability, please work with your manager to complete the Regular Schedule Form.
      </p>

      {/* <h3 className="text-xl font-semibold text-center mb-4">Schedule Request Form – New York City</h3> */}
      
      {/* <div className="mb-4">
        <strong>Employee Name:</strong> John Doe
      </div>
      
      <div className="mb-4">
        <strong>Restaurant Location:</strong> 2549
      </div>
      
      <div className="mb-4">
        <strong>Date of Request:</strong> 4/7/25
      </div> */}

      <div className="mb-4">
        <strong>Request Details:</strong>
        <ul className="list-disc ml-6">
          <li>I would like to request a change to the posted schedule.</li>
          <li>I would like to voluntarily drop the following shift(s) or hours from the posted schedule.</li>
          <li>I would like to voluntarily pick up the following shift(s) or hours.</li>
        </ul>
      </div>

      {/* <div className="mb-6">
        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={isAccepted}
            onChange={handleAccept}
            className="h-5 w-5 text-blue-600 border-gray-300 rounded"
          />
          <span className="text-lg">I accept the privacy policy</span>
        </label>
      </div> */}
{/* 
      {isAccepted && (
        <div className="bg-green-100 text-green-700 p-4 mb-6 rounded">
          <p>Your privacy policy has been accepted.</p>
        </div>
      )} */}

      <div className="mb-6">
        <strong>Date:</strong> {getEstDateTime().toLocaleDateString()} 
      </div>

      <footer className="text-center text-sm text-gray-300">
        <p>For any concerns or questions, please contact us at <span className="text-blue-900">support@delightrestaurantgroup.com</span></p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
